import {
  abeCashupAllOrderedRead,
  abeCashupAllPagedRead,
  abeCashupAllRead,
  abeCashupOwnOrderedRead,
  abeCashupOwnPagedRead,
  abeCashupOwnRead,
} from 'actions/cashup/beCashup.action';
import beCashupBreakdown from 'actions/cashup/beCashupBreakdown.action';
import { abeCashupVouchersRead } from 'actions/cashup/beCashupVoucher.action';
import beGetCashup from 'actions/cashup/beGetCashup.action';
import beGetReconcile from 'actions/cashup/beGetReconcile.action';
import beListReconcile from 'actions/cashup/beListReconcile.action';
import beSaveCashupReconcile from 'actions/cashup/beSaveCashupReconcile.action';
import { CLEAN_CASHUP_DATA } from 'actions/cashup/feCleanCashupData.types';
import { SET_SELECTED_STAFF } from 'actions/cashup/feSetSelectedStaff.types';
import { UPDATE_CASHUP_DATA } from 'actions/cashup/feUpdateCashupData.types';
import { feCleanCheckoutData } from 'actions/ui.actions';
import STAFF_GROUP from 'constants/staff/group.const';
import STAFF_NAME from 'constants/staff/name.const';
import fromActionToMessage from 'utils/converters/backend/fromActionToMessage.util';
import fromAnyToNumber from 'utils/converters/fromAnyToNumber.util';
import asObject from 'utils/objects/asObject.util';

import {
  CHECK_VOUCHER_FAILURE,
  CHECK_VOUCHER_REQUEST,
  CHECK_VOUCHER_SUCCESS,
  CLEAR_CREATED_VOUCHER,
  CREATE_VOUCHER_FAILURE,
  CREATE_VOUCHER_REQUEST,
  CREATE_VOUCHER_SUCCESS,
  DELETE_VOUCHER_FAILURE,
  DELETE_VOUCHER_REQUEST,
  DELETE_VOUCHER_SUCCESS,
  FETCH_CASHUP_DEPOSITS_FAILURE,
  FETCH_CASHUP_DEPOSITS_REQUEST,
  FETCH_CASHUP_DEPOSITS_SUCCESS,
  GENERATE_VOUCHER_FAILURE,
  GENERATE_VOUCHER_REQUEST,
  GENERATE_VOUCHER_SUCCESS,
  GET_ALL_VOUCHER_FAILURE,
  GET_ALL_VOUCHER_REQUEST,
  GET_ALL_VOUCHER_SUCCESS,
  GET_CASHUP_VOUCHER_FAILURE,
  GET_CASHUP_VOUCHER_REQUEST,
  GET_CASHUP_VOUCHER_SUCCESS,
  GET_PRICE_FAILURE,
  GET_PRICE_REQUEST,
  GET_PRICE_SUCCESS,
  GET_TRANSACTIONS_BY_STYLIST_FAILURE,
  GET_TRANSACTIONS_BY_STYLIST_SUCCESS,
  GET_TRANSACTIONS_STYLIST_REQUEST,
  HIDE_CASHUP_ERROR,
  RESET_SAVED,
  TRANSACTION_LOG_CSV_FAILURE,
  TRANSACTION_LOG_CSV_REQUEST,
  TRANSACTION_LOG_CSV_SUCCESS,
  UPDATE_VOUCHER_FAILURE,
  UPDATE_VOUCHER_REQUEST,
  UPDATE_VOUCHER_SUCCESS,
  VOID_TRANSACTION_DETAILS_FAILURE,
  VOID_TRANSACTION_DETAILS_REQUEST,
  VOID_TRANSACTION_DETAILS_SUCCESS,
} from 'cashup/actions';
import { CLEAN_TRANSACTION_DATA } from 'checkout/constants';

const float = (value) => fromAnyToNumber(value) || 0;

const number = (value) => {
  const converted = value - 0; // if you take out a 0, it will turn string into a number, even a NaN
  return Number.isFinite(converted) ? converted : 0; // finite means no NaN and no Infinity
};

const cashupReducer = (
  state = {
    isFetching: false,
    isFetchingReconcile: false,
    isFetchingOrdered: false,
    isSending: false,
    saved: false,
    data: {
      startDate: '',
      endDate: '',
      totalTakings: 0,
      deposits_amount: null, // Object
      vouchers_amount: null, // Object
      totalCash: 0,
      totalOnlineCard: 0,
      totalSalonCard: 0,
      cashReceiptTotal: 0,
      cashInTillStart: 0,
      pettyCashOut: 0,
      cashTakenToBank: 0,
      expectedCashInTill: 0,
      actualCashInTill: 0,
      differenceActualVsExpected: 0,
      totalOther: 0,
      totalTip: 0,
      notes: '',
      deposits: [],
    },
    apiData: {
      count: 0,
      next: null,
      openingCashInTill: 0,
      previous: null,
      results: [],
      total: 0,
      totalCash: 0,
      totalOnlineCard: 0,
      totalSalonCard: 0,
      totalOther: 0,
      totalTip: 0,
      deposits_amount: null, // Object
      vouchers_amount: null, // Object
      notes: '',
      deposits: [],
    },
    depositApiData: {
      depositsLogs: [],
      isFetching: false,
      errorMessage: '',
    },
    response: {},
    errorMessage: '',
    reconcileList: null,
    selectedStaff: { staff: STAFF_NAME.all, name: STAFF_NAME.all, group: STAFF_GROUP.all, selectedStylistIds: [] },
    voucherList: null,
    voucherNumberGenerated: null,
    voucherCreated: null,
    cashupVoucherList: null,
    changedVoucherIndex: null,
    apiTransactionData: null,
  },
  action,
) => {
  const { type } = asObject(action);
  if (!type) return state;

  const { params, errorMessage, selectedStylistIds, staff, data, response, group, name, is } = asObject(action);
  const { id: paramsId, index, NewTransactionId: paramsNewTxId } = asObject(params);

  const rv1 = asObject(response); // response version 1 - old version
  const { json: rv3 } = asObject(action); // response version 3 - new version

  switch (type) {
    case beSaveCashupReconcile.AT.init:
      return { ...state, saved: false };

    case beSaveCashupReconcile.AT.pass: {
      if (!is.ok) return { ...state, errorMessage: fromActionToMessage(action) };
      return { ...state, response: rv3, errorMessage: '', saved: true };
    }
    case beSaveCashupReconcile.AT.fail:
      return { ...state, errorMessage: fromActionToMessage(action) };

    // FIXME: fallthrough
    case beGetCashup.AT.fail:
    case abeCashupAllRead.AT.fail:
    case abeCashupAllPagedRead.AT.fail:
    case abeCashupAllOrderedRead.AT.fail:
    case abeCashupOwnRead.AT.fail:
    case abeCashupOwnPagedRead.AT.fail:
    case abeCashupOwnOrderedRead.AT.fail:
      return { ...state, errorMessage: fromActionToMessage(action) };

    // FIXME: fallthrough
    case beGetReconcile.AT.pass:
    case beListReconcile.AT.pass: {
      // reconcile has a habbit of returning 404 for missing data, not an actual error for fromActionToMessage
      if (beGetReconcile.AT.pass === type && is.notFound) return state;
      if (!is.ok) return { ...state, errorMessage: fromActionToMessage(action) };

      const d = { ...state.data };

      if (Object.keys(rv3 || {}).includes('results')) {
        d.cashTakenToBank = float(rv3.total_cashBanked);
        d.actualCashInTill = float(rv3.total_endCashInTill) + number(d.totalCash);
        d.pettyCashOut = float(rv3.total_pettyCash);
        d.cashReceiptTotal = float(rv3.total_salonCardReceipts);
        d.cashInTillStart = float(rv3.total_startCashInTill);
        d.expectedCashInTill =
          number(rv3.total_startCashInTill) +
          number(d.totalCash) +
          number(d.deposits_amount ? d.deposits_amount.cash : 0) -
          number(rv3.total_pettyCash) -
          number(rv3.total_cashBanked);
        d.differenceActualVsExpected = d.actualCashInTill - d.expectedCashInTill;
      } else {
        d.cashTakenToBank = float(rv3.cashBanked);
        d.actualCashInTill = float(rv3.endCashInTill);
        d.notes = rv3.notes;
        d.pettyCashOut = float(rv3.pettyCash);
        d.cashReceiptTotal = float(rv3.salonCardReceipts);
        d.cashInTillStart = float(rv3.startCashInTill);
        const depositAmount = d.deposits_amount ? number(d.deposits_amount.cash) : 0;
        d.expectedCashInTill =
          number(d.cashInTillStart) +
          number(d.totalCash) +
          number(depositAmount) -
          number(d.pettyCashOut) -
          number(d.cashTakenToBank);
        d.differenceActualVsExpected = number(d.actualCashInTill) - number(d.expectedCashInTill);
      }
      return { ...state, data: d, reconcileList: rv3 };
    }

    // FIXME: fallthrough
    case beCashupBreakdown.AT.pass:
    case beGetCashup.AT.pass:
    case abeCashupAllRead.AT.pass:
    case abeCashupAllPagedRead.AT.pass:
    case abeCashupAllOrderedRead.AT.pass:
    case abeCashupOwnRead.AT.pass:
    case abeCashupOwnPagedRead.AT.pass:
    case abeCashupOwnOrderedRead.AT.pass: {
      if (!is.ok) return { ...state, errorMessage: fromActionToMessage(action) };

      const data = Object.assign({}, state.data);
      const totalTakings = number(rv3.total);

      data.totalTakings =
        totalTakings +
        (rv3.deposits_amount ? number(rv3.deposits_amount.total) : 0) +
        (rv3.vouchers_amount ? number(rv3.vouchers_amount.total) : 0);
      data.totalCash = number(rv3.totalCash) + (rv3.vouchers_amount ? number(rv3.vouchers_amount.cash) : 0);
      data.totalOnlineCard = number(rv3.totalOnlineCard);
      data.totalSalonCard = number(rv3.totalSalonCard) + (rv3.vouchers_amount ? number(rv3.vouchers_amount.card) : 0);
      data.deposits_amount = asObject(rv3.deposits_amount);
      data.vouchers_amount = asObject(rv3.vouchers_amount);
      data.totalOther = number(rv3.totalOther);
      data.totalTip = number(rv3.totalTip);
      data.cashInTillStart = number(rv3.openingCashInTill);
      data.cashReceiptTotal = 0;
      data.pettyCashOut = 0;
      data.cashTakenToBank = 0;

      const depositAmount = data.deposits_amount ? number(data.deposits_amount.cash) : 0;
      data.expectedCashInTill =
        number(data.cashInTillStart) +
        number(data.totalCash) +
        number(depositAmount) -
        number(data.pettyCashOut) -
        number(data.cashTakenToBank);
      data.actualCashInTill = 0;
      data.differenceActualVsExpected = data.actualCashInTill - data.expectedCashInTill;
      data.notes = rv3.notes;
      data.deposits = rv3.deposits;
      return { ...state, data, apiData: rv3, errorMessage: '' };
    }

    case abeCashupVouchersRead.AT.init:
      return { ...state, isFetching: true };

    case abeCashupVouchersRead.AT.pass:
      return { ...state, isFetching: false, voucherSoldList: rv3 || null };

    case abeCashupVouchersRead.AT.fail:
      return { ...state, isFetching: false, errorMessage };

    case CHECK_VOUCHER_REQUEST:
      return { ...state, isFetching: true, errorMessage: '', changedVoucherIndex: index };
    case CHECK_VOUCHER_SUCCESS:
      return { ...state, isFetching: false };
    case CHECK_VOUCHER_FAILURE:
      return { ...state, isFetching: false, errorMessage };

    case GENERATE_VOUCHER_REQUEST:
      return { ...state, isFetching: true };
    case DELETE_VOUCHER_REQUEST:
      return { ...state, isFetching: true };
    case GET_ALL_VOUCHER_REQUEST:
      return { ...state, isFetching: true };
    case CREATE_VOUCHER_REQUEST:
      return { ...state, isFetching: true };
    case UPDATE_VOUCHER_REQUEST:
      return { ...state, isFetching: true };
    case GET_CASHUP_VOUCHER_REQUEST:
      return { ...state, isFetching: true };
    case GENERATE_VOUCHER_FAILURE:
      return { ...state, isFetching: false, errorMessage };
    case DELETE_VOUCHER_FAILURE:
      return { ...state, isFetching: false, errorMessage };
    case GET_ALL_VOUCHER_FAILURE:
      return { ...state, isFetching: false, errorMessage };
    case CREATE_VOUCHER_FAILURE:
      return { ...state, isFetching: false, errorMessage, voucherCreated: 'failed' };
    case UPDATE_VOUCHER_FAILURE:
      return { ...state, isFetching: false, errorMessage };
    case GET_CASHUP_VOUCHER_FAILURE:
      return { ...state, isFetching: false, errorMessage };
    case GENERATE_VOUCHER_SUCCESS:
      return { ...state, isFetching: false, voucherNumberGenerated: response };
    case DELETE_VOUCHER_SUCCESS: {
      const voucherList = state.voucherList.slice();
      let deleteMessage = '';

      if (!Object.keys(rv1).length) {
        for (let i = 0; i < voucherList.length; i += 1) {
          if (voucherList[i].id === paramsId) {
            voucherList.splice(i, 1);
            break;
          }
        }
      } else {
        deleteMessage = response;
      }
      return { ...state, voucherList, isFetching: false, deleteMessage };
    }
    case GET_ALL_VOUCHER_SUCCESS:
      return { ...state, isFetching: false, voucherList: response };
    case CREATE_VOUCHER_SUCCESS:
      return { ...state, isFetching: false, voucherCreated: response };
    case CLEAR_CREATED_VOUCHER:
      return { ...state, voucherCreated: null };
    case UPDATE_VOUCHER_SUCCESS:
      return { ...state, isFetching: false };
    case GET_CASHUP_VOUCHER_SUCCESS:
      return { ...state, isFetching: false, cashupVoucherList: response };
    case GET_PRICE_REQUEST:
      return { ...state, isFetching: true };
    case GET_PRICE_SUCCESS:
      return { ...state, isFetching: false, priceList: response };
    case GET_PRICE_FAILURE:
      return { ...state, isFetching: false, errorMessage };

    case RESET_SAVED:
      return { ...state, isSending: false, errorMessage: '', saved: false };
    case UPDATE_CASHUP_DATA: {
      const expectedCashInTill =
        +data.cashInTillStart +
        +data.totalCash +
        +(data.deposits_amount ? data.deposits_amount.cash : 0) -
        +data.pettyCashOut -
        +data.cashTakenToBank;

      return {
        ...state,
        data: {
          ...data,
          expectedCashInTill,
          differenceActualVsExpected: data.actualCashInTill - expectedCashInTill,
        },
      };
    }
    case CLEAN_CASHUP_DATA: {
      return {
        ...state,
        data: {
          startDate: '',
          endDate: '',
          totalTakings: 0,
          totalCash: 0,
          totalOnlineCard: 0,
          totalSalonCard: 0,
          totalTip: 0,
          totalOther: 0,
          cashReceiptTotal: 0,
          cashInTillStart: 0,
          pettyCashOut: 0,
          cashTakenToBank: 0,
          expectedCashInTill: 0,
          actualCashInTill: 0,
          differenceActualVsExpected: 0,
          deposits_amount: null,
          vouchers_amount: null,
          notes: '',
          deposits: [],
        },
        apiData: {
          count: 0,
          next: null,
          openingCashInTill: 0,
          previous: null,
          results: [],
          total: 0,
          totalCash: 0,
          totalOnlineCard: 0,
          totalSalonCard: 0,
          totalOther: 0,
          deposits_amount: null,
          vouchers_amount: null,
          totalTip: 0,
          notes: '',
          deposits: [],
        },
        response: {},
        saved: false,
      };
    }

    case TRANSACTION_LOG_CSV_REQUEST:
      return { ...state };
    case TRANSACTION_LOG_CSV_SUCCESS:
      return { ...state };
    case TRANSACTION_LOG_CSV_FAILURE:
      return { ...state, errorMessage };
    case HIDE_CASHUP_ERROR:
      return { ...state, errorMessage: '' };
    case VOID_TRANSACTION_DETAILS_REQUEST:
      return { ...state };
    case VOID_TRANSACTION_DETAILS_SUCCESS: {
      if (state.apiData) {
        const { data, apiData } = state;
        const updatedData = {
          ...data,
          totalTakings: data.totalTakings - rv1.partCash - rv1.cardAmount - rv1.onlineAmount - rv1.otherAmount,
          totalCash: data.totalCash - rv1.partCash,
          totalSalonCard: data.totalSalonCard - rv1.cardAmount,
          totalOnlineCard: data.totalOnlineCard - rv1.onlineAmount,
          totalTip: data.totalTip - rv1.tipAmount,
          totalOther: data.totalOther - rv1.otherAmount,
        };

        const { results: apiDataResults } = apiData;

        const newTransaction = {
          id: paramsNewTxId || 0,
          created_from: rv1.id ? rv1.id : 0,
          clients: rv1.clients ? [...rv1.clients] : [],
          additionalDiscount: rv1.additionalDiscount ? rv1.additionalDiscount : 0,
          additionalDiscountType: rv1.additionalDiscountType ? rv1.additionalDiscountType : '',
          additionalDiscountReason: rv1.additionalDiscountReason ? rv1.additionalDiscountReason : '',
          deposits: { clientDeposits: rv1.deposits, isFetching: false, errorMessage: '' },
          otherAmount: rv1.otherAmount ? Math.abs(rv1.otherAmount) : 0,
          tipAmount: rv1.tipAmount ? Math.abs(rv1.tipAmount) : 0,
          tipType: rv1.tipType ? rv1.tipType : '',
          partCash: rv1.partCash ? Math.abs(rv1.partCash) : 0,
          cardAmount: rv1.cardAmount ? Math.abs(rv1.cardAmount) : 0,
          onlineAmount: rv1.onlineAmount ? Math.abs(rv1.onlineAmount) : 0,
          total: rv1.total ? rv1.total - rv1.total - rv1.total : 0,
          balanceToPay: rv1.total || 0,
          paymentType: rv1.paymentType ? rv1.paymentType : '',
          created: rv1.created ? rv1.created : '',
          is_void: true,
          is_no_show_fee: false,
        };

        const updatedResults = apiDataResults.map((result) => {
          if (response) {
            const id = rv1.id ? rv1.id : 0;
            if (result.id === id) {
              return { ...result, void_created: true };
            }
          }
          return result;
        });
        return {
          ...state,
          data: updatedData,
          apiData: { ...apiData, results: [...updatedResults, { ...newTransaction }] },
        };
      }
      return { ...state };
    }
    case VOID_TRANSACTION_DETAILS_FAILURE:
      return { ...state };
    case FETCH_CASHUP_DEPOSITS_REQUEST:
      return { ...state, depositApiData: { depositsLogs: [], isFetching: true, errorMessage: '' } };
    case FETCH_CASHUP_DEPOSITS_SUCCESS:
      return { ...state, depositApiData: { depositsLogs: response, isFetching: false, errorMessage: '' } };
    case FETCH_CASHUP_DEPOSITS_FAILURE:
      return { ...state, depositApiData: { depositsLogs: [], isFetching: false, errorMessage } };
    case feCleanCheckoutData.AT.name:
    case CLEAN_TRANSACTION_DATA:
      return { ...state };
    case beCashupBreakdown.AT.init:
      return { ...state, isFetching: true, errorMessage: '' };
    case beCashupBreakdown.AT.fail:
      return { ...state, isFetching: false, errorMessage };
    case GET_TRANSACTIONS_STYLIST_REQUEST:
      return { ...state, isFetching: true, errorMessage: '' };
    case GET_TRANSACTIONS_BY_STYLIST_SUCCESS:
      return { ...state, apiTransactionData: response.length > 100 ? response : null, isFetching: false };
    case GET_TRANSACTIONS_BY_STYLIST_FAILURE:
      return { ...state, isFetching: false, errorMessage };
    case SET_SELECTED_STAFF:
      return {
        ...state,
        selectedStaff: {
          ...state.selectedStaff,
          staff: staff ?? STAFF_NAME.all, // if value of staff from the action; otherwise STAFF_NAME.all.
          selectedStylistIds: selectedStylistIds ?? [],
          name: name ?? STAFF_NAME.all,
          group: group ?? STAFF_GROUP.all,
        },
      };

    default:
      return state;
  }
};

export default cashupReducer;
